module.exports = __webpack_public_path__ + "static/img/ubg6.748cfd0b.png";